package ru.villawonka.app.presentation.design.extensions

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyItemScope
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp

@Composable
fun ColumnScope.AppSpacer(size: Dp) {
    Spacer(modifier = Modifier.height(size))
}

@Composable
fun RowScope.AppSpacer(size: Dp) {
    Spacer(modifier = Modifier.width(size))
}

@Composable
fun LazyListScope.AppSpacer(size: Dp) {
    Spacer(modifier = Modifier.height(size))
}

@Composable
fun LazyItemScope.AppSpacer(size: Dp) {
    Spacer(modifier = Modifier.height(size))
}
